import * as React from "react"
import {Navigate} from "react-router-dom";

import AppLayout from "Layout";
import {SKU_DETAILS_ROUTES} from "@constants"
import SkuDetailsPage from ".";


export const SkuDetailsRoutes = {
    path: SKU_DETAILS_ROUTES.PATH,
    title: SKU_DETAILS_ROUTES.TITLE,
    accessKey: SKU_DETAILS_ROUTES.ACCESS_KEY,
    icon: 'circle-info',
    element: <AppLayout />,
    description: "View comprehensive details of a specific SKU: distribution, pricing, stock, and product page for a single date or date range.",
    children: [{
        element: <Navigate to={SKU_DETAILS_ROUTES.SKU_DETAILS_URL} replace />,  index: true
    }, {
        title: SKU_DETAILS_ROUTES.SKU_DETAILS_TITLE,
        path: SKU_DETAILS_ROUTES.SKU_DETAILS_URL,
        dashboardKey: SKU_DETAILS_ROUTES.SKU_DETAILS_ID,
        element: <SkuDetailsPage />
    }]
}
